import AgentChatBackground from '../../../../../../../assets/images/Chat_background/Agent_Chat_background.png';
import { useSupport } from '../../../../../../../context/support/SupportContext';
import TripContextCard from './TripContextCard';
import MessageBubble from './MessageBubble';

const MessageStream = () => {
  const { chatThread, activeVoucherInfo, travellerChatContainerRef } = useSupport();

  if (!chatThread) return null;

  return (
    <div
      ref={travellerChatContainerRef}
      className="flex-1 overflow-y-auto p-4 md:p-6 space-y-4 custom-scrollbar"
      style={{
        backgroundImage: `url(${AgentChatBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Trip Context Card */}
      <TripContextCard
        activeVoucherInfo={activeVoucherInfo}
        bookingId={chatThread.booking_id}
      />

      {chatThread.messages?.map((msg, idx) => (
        <MessageBubble
          key={msg._id || idx}
          message={msg}
          guestName={chatThread.guest_name}
        />
      ))}
    </div>
  );
};

export default MessageStream;
